<ion-content [fullscreen]="true" class="page-content" color="light">
  <!-- Tabella Clienti -->
  <generic-table
    style="width: 100%; height: 100%"
    [tableColumns]="tableColumns"
    [data]="tableData"
    [config]="tableConfigParams"
    [isLoading]="isDataLoading"
    (onOptionAction)="onOptionAction($event)"
    (onCtaAction)="onCtaAction($event)"
    (onPaginatorChange)="paginatorChange($event)"
  ></generic-table>
</ion-content>